import { render, staticRenderFns } from "./sendUserList.vue?vue&type=template&id=98c79e6c&scoped=true&"
import script from "./sendUserList.vue?vue&type=script&lang=js&"
export * from "./sendUserList.vue?vue&type=script&lang=js&"
import style0 from "./sendUserList.vue?vue&type=style&index=0&id=98c79e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c79e6c",
  null
  
)

export default component.exports